import React from "react";
import { getAdminPortalLoginUrl } from "@/lib/site";

/** `/admin` bookmarks on the marketing host go to the real admin app. */
export default function AdminPortalRedirect() {
  React.useEffect(() => {
    window.location.replace(getAdminPortalLoginUrl());
  }, []);
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f8fafc] text-slate-600 text-sm">
      Redirecting to admin…
    </div>
  );
}
